import styled, { css } from 'styled-components';
import { HideScrollbar } from '../../global/commonStyle';
const DrawerOverlay = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--background-overlay);
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  transition: opacity var(--transition-normal) ease-in-out, visibility var(--transition-normal) ease-in-out;
  z-index: var(--z-index-modal);
`;

const DrawerContent = styled.div<{ open: boolean; placement: string; width: string }>`
  position: fixed;
  background-color: var(--background-primary);
  transition: transform var(--transition-normal) ease-in-out;
  z-index: var(--z-index-toast);
  width: ${({ width }) => width};
  height: 100%;
  ${({ placement, open, width }) => {
    switch (placement) {
      case 'right':
        return `
          right: ${open ? '0' : '-100%'};
          top: 0;
        `;
      case 'left':
        return `
          left: ${open ? '0' : '-100%'};
          top: 0;
        `;
      case 'top':
        return `
          top: ${open ? '0' : '-100%'};
          left: 0;
          width: 100%;
          height: ${width};
        `;
      case 'bottom':
        return `
          bottom: ${open ? '0' : '-100%'};
          left: 0;
          width: 100%;
          height: ${width};
        `;
      default:
        return '';
    }
  }}
`;

const DrawerBody = styled.div<{ isDesktopApp?: boolean }>`
  height: 100%;
  ${HideScrollbar}
  ${({ isDesktopApp }) =>
    isDesktopApp &&
    css`
      border-top-right-radius: var(--border-radius-8);
      border-bottom-right-radius: var(--border-radius-8);
    `}
`;

export { DrawerOverlay, DrawerContent, DrawerBody };
